<template>
  <div class='h100-40 width-100vw'>
    <ejs-grid ref='grid' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc' :excelExportComplete='excelExportComplete' :actionComplete='actionComplete'
              :editSettings='editOptions' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='alarmTypeStr' :headerText='$t("Alarm.alarmType")' textAlign='Center' minWidth='10' :formatter='typeFormat'></e-column>
        <e-column field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10'></e-column>
        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' minWidth='10' :formatter='clearFormat'></e-column>
        <e-column field='confirmStateStr' :headerText='$t("Alarm.confirmState")' textAlign='Center' minWidth='10' :formatter='confirmFormat' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearTimeFormat' :headerText='$t("Alarm.clearTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmTimeFormat' :headerText='$t("Alarm.confirmTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearUsrName' :headerText='$t("Alarm.clearUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmUsrName' :headerText='$t("Alarm.confirmUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>

        <e-column field='messageNo' :isPrimaryKey='true' :headerText='$t("Alarm.messageNo")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='comment' :headerText='$t("Alarm.remark")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='brdTypeStr' :headerText='$t("Alarm.brdType")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxdwinfo1' :headerText='$t("Alarm.xxdwinfo1")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxdwinfo2' :headerText='$t("Alarm.xxdwinfo2")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo1' :headerText='$t("Alarm.xxkzinfo1")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo2' :headerText='$t("Alarm.xxkzinfo2")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo3' :headerText='$t("Alarm.xxkzinfo3")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo4' :headerText='$t("Alarm.xxkzinfo4")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='cause' :headerText='$t("Alarm.cause")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='advise' :headerText='$t("Alarm.advise")' :visible='false' textAlign='Center' width='9%'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getAlarmListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='syncDialog' :element='syncDialogSetting.element' :styles='syncDialogSetting.styles'>
      <template v-slot:dialog-content>
        <div class='h-dialogContainer syncTopoTree'>
          <!--          <TopoTree ref='syncContent' :searchBox='{ show: false }' :checkBox='{ show: true }'></TopoTree>-->
          <!--          <TopoList ref='syncContent'></TopoList>-->
          <AlarmTopoTree ref='syncContent'></AlarmTopoTree>
        </div>
      </template>
    </CustomDialog>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmDetail ref='detailContent'></AlarmDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmFilter url='/lte/ems/fm/alarmcurrent/filter' ref='filterContent' :hasStatus='true'></AlarmFilter>
      </template>
    </CustomDialog>
    <CustomDialog ref='autoConfirmDialog' :element='autoConfirmDialogSetting.element' :styles='autoConfirmDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AutoConfirm ref='autoConfigContent'></AutoConfirm>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  const a = true;
  import { Edit, Reorder, Resize, ExcelExport, ContextMenu, GridPlugin, VirtualScroll, GridComponent } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../common/CustomDialog';
  import AlarmTopoTree from './AlarmTopoTree';
  import AlarmDetail from './AlarmDetail';
  import AlarmFilter from './AlarmFilter';
  import AutoConfirm from './AutoConfirmSetting';
  import socketInstance from '../../../plugins/stompSock';
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'currentAlarmTable',
    components: {
      AlarmTopoTree,
      CustomDialog,
      AlarmDetail,
      AlarmFilter,
      AutoConfirm
    },
    props: {
      roleNe: {
        type: Array,
        default() {
          return [];
        }
      },
      roleNetMap: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        editOptions: { allowAdding: true, allowDeleting: true, newRowPosition: 'Top' },
        selectionOptions: { type: 'Multiple' },
        contextMenuItems: [
          { text: `${this.$t('Alarm.confirm')}` },
          { text: `${this.$t('Alarm.clear')}` },
          { text: `${this.$t('Alarm.shield')}` },
          { text: `${this.$t('Alarm.alarmDetails')}` }
        ],
        alarmSocketMaxCapcity: 15,
        conditionsStatus: false,
        topoList: [],
        isOn: '0',
        disabled: true,
        page: {
          pageNo: 1,
          pageSize: 16,
          totalCount: 0,
          pageCount: 10
        },
        queryConditions: {
          systemId: '1',
          conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
          keywords: '', // 模糊查询关键字
        },
        data: {},
        clearOrConfirmMessage: '',
        isAutoOption: true, // 记录当前是否为自动清除告警
        syncDialogSetting: {
          styles: {
            width: '600px',
            height: '70%',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.alarmAynchronize'),
            refName: 'sync',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
              { click: this.syncConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
            ]
          }
        },
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.alarmDetails'),
            target: '#app',
            refName: 'detail',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.close'), isPrimary: true } }
            ]
          }
        },
        filterDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.filterSetting'),
            refName: 'filter',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
              { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
            ]
          }
        },
        autoConfirmDialogSetting: {
          styles: {
            width: '400px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.confirmSetting'),
            refName: 'autoConfirm',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
              { click: this.autoConfirmSureFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
            ]
          }
        },
        websocketSetting: [
          // { topic: '/topic/#', clientId: 'CurrentAlarmServer', callback: this.websocketCallback }
          { topic: '/user/#/CurrentAlarmServer', clientId: 'alarm', callback: this.websocketCallback }
        ]
      };
    },
    provide: {
      grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu, VirtualScroll]
    },
    watch: {
      // roleNe() {
      //   this.getAlarmListData();
      // }
    },
    methods: {
      levelFormat(grids, data) {
        data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
        return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
      },
      typeFormat(grid, data) {
        let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
        data.alarmTypeStr = str;
        return str;
      },
      clearFormat(grid, data) {
        let str = this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
        data.clearStateStr = str;
        return str;
      },
      confirmFormat(grid, data) {
        let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
        data.confirmStateStr = str;
        return str;
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList[childList.length - 1].style.display = this.getCheckedData(true).length > 1 ? 'none' : 'block';
      },
      menuClickFunc(menuArgs) { // 为右键分配事件
        switch (menuArgs.element.innerText) {
          case `${this.$t('Alarm.confirm')}`:
            this.confirmAlarm();
            break;
          case `${this.$t('Alarm.clear')}`:
            this.clearAlarm();
            break;
          case `${this.$t('Alarm.shield')}`:
            this.shieldAlarm();
            break;
          case `${this.$t('Alarm.alarmDetails')}`:
            this.showDetail();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.syncDialog.clear();
        this.$refs.syncDialog.close();
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
        this.$refs.filterDialog.clear();
        this.$refs.filterDialog.close();
        this.$refs.autoConfirmDialog.clear();
        this.$refs.autoConfirmDialog.close();
      },
      getColumnsMapper() {
        return `alarmID:${this.$t('Alarm.alarmID')};`
          + `alarmName:${this.$t('Alarm.alarmName')};`
          + `levelStr:${this.$t('Alarm.alarmLevel')};`
          + `alarmTypeStr:${this.$t('Alarm.alarmType')};`
          + `neTypeStr:${this.$t('Alarm.neType')};`
          + `neName:${this.$t('Alarm.neName')};`
          + `neAlarmFDN:${this.$t('Alarm.neAlarmFDN')};`
          + `clearStateStr:${this.$t('Alarm.clearState')};`
          + `confirmStateStr:${this.$t('Alarm.confirmState')};`
          + `createTimeFormat:${this.$t('Alarm.createTime')};`
          + `clearTimeFormat:${this.$t('Alarm.clearTime')};`
          + `confirmTimeFormat:${this.$t('Alarm.confirmTime')};`
          + `clearUsrName:${this.$t('Alarm.clearUser')};`
          + `confirmUsrName:${this.$t('Alarm.confirmUser')};`
          + `comment:${this.$t('Alarm.remark')};`
          + `xxdwinfo1:${this.$t('Alarm.xxdwinfo1')};`
          + `xxdwinfo2:${this.$t('Alarm.xxdwinfo2')};`
          + `xxkzinfo1:${this.$t('Alarm.xxkzinfo1')};`
          + `xxkzinfo2:${this.$t('Alarm.xxkzinfo2')};`
          + `xxkzinfo3:${this.$t('Alarm.xxkzinfo3')};`
          + `xxkzinfo4:${this.$t('Alarm.xxkzinfo4')};`
          + `cause:${this.$t('Alarm.cause')};`
          + `advise:${this.$t('Alarm.advise')};`;
      },
      websocketInit() {
        socketInstance.init(this.websocketSetting);
      },
      websocketCallback(msg) {
        const data = JSON.parse(msg.body);
        if (data.type === 'currentAlarm') { // 新告警
          if (parseInt(this.isOn, 10) === 1) {
            const alarmDataList = JSON.parse(data.data);
            if (this.alarmSocketCapcityFlag(alarmDataList)) {
              this.getAlarmListData();
            } else {
              for (let i = 0; i < alarmDataList.length; i++) {
                setTimeout(() => {
                  if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
                    this.$refs.grid.addRecord(alarmDataList[i]);
                    const count = {
                      totalAlarmCount: 0,
                      criticalAlarmCount: 0,
                      majorAlarmCount: 0,
                      minorAlarmCount: 0,
                      warningAlarmCount: 0
                    };
                    count.totalAlarmCount = 1;
                    switch (alarmDataList[i].level) {
                      case 0: count.criticalAlarmCount = 1; break;
                      case 1: count.majorAlarmCount = 1; break;
                      case 2: count.minorAlarmCount = 1; break;
                      case 3: count.warningAlarmCount = 1; break;
                      default:
                    }
                    this.$emit('updataCount', count);
                  }
                }, (parseInt(1000 / this.alarmSocketMaxCapcity)) * i);
              }
            }
          }
        } else if (data.type === 'autoAlarm') {
          const removeAlarmDataList = JSON.parse(data.data).removeData;
          const alarmDataList = JSON.parse(data.data).updateData;
          for (let i = 0; i < removeAlarmDataList.length; i++) {
            const index = this.data.findIndex(v => v.messageNo === parseInt(removeAlarmDataList[i], 10));
            if (index > -1) {
              const rowData = this.data[index];
              const count = {
                totalAlarmCount: 0,
                criticalAlarmCount: 0,
                majorAlarmCount: 0,
                minorAlarmCount: 0,
                warningAlarmCount: 0
              };
              count.totalAlarmCount = -1;
              switch (rowData.level) {
                case 0: count.criticalAlarmCount = -1; break;
                case 1: count.majorAlarmCount = -1; break;
                case 2: count.minorAlarmCount = -1; break;
                case 3: count.warningAlarmCount = -1; break;
                default:
              }
              this.$emit('updataCount', count);
              this.$refs.grid.deleteRecord("messageNo", rowData);
            }
          }
          for (let i = 0; i < alarmDataList.length; i++) {
            const index = this.data.findIndex(v => v.messageNo === alarmDataList[i].messageNo);
            if (index > -1) {
              this.$refs.grid.updateRow(alarmDataList[i].messageNo, alarmDataList[i]);
            }
          }
        }
      },
      alarmSocketCapcityFlag(alarmDataList) {
        console.log('alarmDataList', alarmDataList.length);
        let almCount = 0;
        for (let i = 0; i < alarmDataList.length; i++) {
          if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
            almCount ++;
            if (almCount === this.alarmSocketMaxCapcity) {
              break;
            }
          }
        }
        if (almCount === this.alarmSocketMaxCapcity) {
          return true;
        }
        return false;
      },
      actionComplete(args) {
        if (args.action === 'add' || args.requestType === 'delete') { // 添加时会默认选中增加的行，现取消选择
          this.$refs.grid.selectRows([]);
        }
        this.disabled = true;
        // this.bindTitle();
        this.$refs.grid.selectRow(0, true);
        this.$refs.grid.selectRow(0, true);
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
          return false;
        }
        return selectedRecords;
      },
      getCheckedVals() {
        const messageNos = [];
        const checkedData = this.getCheckedData(true);
        for (let i = 0; i < checkedData.length; i++) {
          messageNos.push(checkedData[i].messageNo);
        }
        return messageNos;
      },
      getAlarmListData(firstFlag) {
        // 获取表格数据
        const This = this;
        let conditionsStr = '';
        let keywordsStr = '';
        if (This.conditionsStatus === true) {
          conditionsStr = This.queryConditions.conditions;
        } else {
          keywordsStr = This.queryConditions.keywords;
        }
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        if (This.page.pageNo == 1) {
          This.$refs.pager.ej2Instances.currentPage = 1;
        }
        this.$emit('count', {
          conditions: conditionsStr,
          keywords: keywordsStr
        });
        if (firstFlag == true) {
          This.page.pageNo = 1;
          This.$refs.pager.ej2Instances.currentPage = 1;
        }

        This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarmPage', {
          page: {
            pageNo: This.page.pageNo,
            pageSize: This.page.pageSize
          },
          conditions: conditionsStr,
          keywords: keywordsStr,
          roleNe: This.roleNe
        }).then((response) => {
          if (response && response.status === 200) {
            console.log("===============")
            This.page.totalCount = response.data.resultVal.totalCount;
            This.data = response.data.resultVal.result;
          }
        });
      },
      exportAlarmListData() {
        const This = this;
        const checkedData = This.getCheckedData(true);
        if (checkedData) {
          const exportProperties = {
            fileName: `${this.$t('Alarm.currentAlarm')}.xlsx`,
            dataSource: checkedData
          };
          This.$refs.grid.getColumns()[0].visible = false;
          for (let i = 17; i < This.$refs.grid.getColumns().length; i++) {
            This.$refs.grid.getColumns()[i].visible = true;
          }
          This.$refs.grid.excelExport(exportProperties);
        }
      },
      excelExportComplete() {
        this.$refs.grid.getColumns()[0].visible = true;
        for (let i = 17; i < this.$refs.grid.getColumns().length; i++) {
          this.$refs.grid.getColumns()[i].visible = false;
        }
      },
      syncFunc() {
        // 同步
        this.$refs.syncDialog.show();
        this.$refs.syncContent.createTree();
        // this.$refs.syncContent.uncheckAll();
      },
      syncConfirmFunc() {
        // 点击同步弹窗确认按钮
        /* 获取树勾选的节点
         * 拼接后调用接口，返回数据后关闭弹窗
         */
        const This = this;
        const neIdList = This.$refs.syncContent.getCheckNode();
        if (neIdList) {
          This.$axios.post('/lte/ems/fm/alarmcurrent/synRule', neIdList).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.syncSuccess')});
            } else {
              EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.syncError')});
            }
            this.dialogHide();
          });
        } else {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectNe')});
        }
      },
      confirmAlarm() {
        // 告警确认
        const This = this;
        const checkedData = This.getCheckedData(true);
        if (checkedData) {
          This.$axios.post('/lte/ems/fm/alarmcurrent/confirm', This.getCheckedVals()).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              This.isAutoOption = false;
              This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
              EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
              This.page.pageNo = 1;
              This.getAlarmListData(true);
            }
          });
        }
      },
      clearAlarm() {
        // 告警清除
        const This = this;
        const checkedData = This.getCheckedData(true);
        if (checkedData) {
          This.$axios.post('/lte/ems/fm/alarmcurrent/clear', This.getCheckedVals()).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              This.isAutoOption = false;
              This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
              EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
              This.page.pageNo = 1;
              This.getAlarmListData(true);
            }
          });
        }
      },
      showDetail() {
        // 告警详情
        const checkedData = this.getCheckedData(false);
        if (checkedData) {
          this.$refs.detailDialog.show();
          this.$refs.detailContent.setAlarmId(checkedData[0]);
        }
      },
      shieldAlarm() {
        // 告警屏蔽
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          this.$axios.post('/lte/ems/fm/alarmcurrent/shield', this.getCheckedVals()).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
            } else {
              EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
            }
          });
        }
      },
      filterFunc() {
        // 告警过滤
        this.$refs.filterDialog.show();
        this.$refs.filterContent.setTopoList(this.topoList);
        this.$refs.filterContent.setConditions(this.queryConditions.conditions);
      },
      filterConfirmFunc(clickEvent) {
        if (clickEvent.keyCode === 13) {
          return;
        }
        // 告警过滤确认事件
        this.queryConditions.conditions = this.$refs.filterContent.getConditions();
        this.topoList = this.$refs.filterContent.getTopoList();
        this.dialogHide();
        this.conditionsStatus = true;
        this.getAlarmListData(true);
      },
      autoConfirmFunc() {
        // 告警自动确认
        this.$refs.autoConfirmDialog.show();
        this.$refs.autoConfigContent.getAutoConfirmInfo();
      },
      autoConfirmSureFunc() {
        // 告警自动确认按钮事件
        const data = this.$refs.autoConfigContent.getConditionData();
        if (data) {
          this.$axios.post('/lte/ems/fm/alarmcurrent/autoConfirmCondition', JSON.parse(data)).then((response) => {
            if (response && response.status === 200) {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
            }
          });
          this.dialogHide();
        }
      },
    },
    mounted() {
      // this.websocketInit();
    },
    beforeDestroy() {
      for (let i = 0; i < this.websocketSetting.length; i++) {
        socketInstance.stopReceiveTopicMsg(this.websocketSetting[i].clientId, this.websocketSetting[i].topic);
      }
    }
  };
</script>
